<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div class="api-campaign-empty-state">
    <p>{{ t('CAMPAIGN.API.EMPTY_STATE') }}</p>
  </div>
</template>

<style scoped>
.api-campaign-empty-state {
  padding: 2rem;
  text-align: center;
}
</style>
